import axios from 'axios';

const apiClient = axios.create({ baseURL: '/' });

// Central response interceptor used by API helpers and contexts.
apiClient.interceptors.response.use(
	(response) => response,
	(error) => {
		const status = error.response?.status;

		if (status === 401) {
			// Session expired or unauthorized: force return to login flow.
			window.location.replace('/login');
		}

		return Promise.reject(error);
	}
);

export default apiClient;
